import NotificationPersistenceService from 'app/services/NotificationPersistenceService';
import { getTrustedUserProfile, handleLogout, isAuthenticated } from 'utils/auth';

const AuthService = {
  logout: () => {
    try {
      NotificationPersistenceService.getInstance().clearAllData();
    } catch (error) {
      // no-op
    }
    void handleLogout();
  },

  getUser: () => getTrustedUserProfile(false),

  isAuthenticated,
};

export default AuthService; 